export default __webpack_public_path__ + "static/media/ding.5948b6f9.wav";